module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0001.cad5ff03.jpg";